// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1MyRr","approved":"Status_approved__vuOan","rejected":"Status_rejected__1-2sd","expired":"Status_expired__3awe5","label":"Status_label__2grYQ"};